const PATIENT_APP_PRODUCTION = "https://app.izzyai.com/";

/** Patient app after payment. A production build never returns localhost. */
export function patientAppUrl() {
  if (process.env.NODE_ENV !== "development") {
    return PATIENT_APP_PRODUCTION;
  }
  const configured = process.env.REACT_APP_PATIENT_APP_URL;
  if (configured) {
    const trimmed = configured.replace(/\/$/, "");
    return `${trimmed}/`;
  }
  return "http://localhost:8080/";
}

/** Use a backend redirect only when it is safe for this build. */
export function safePatientRedirect(url) {
  const fallback = patientAppUrl();
  if (!url || url === "/") {
    return fallback;
  }
  if (process.env.NODE_ENV !== "development" && /localhost|127\.0\.0\.1/i.test(url)) {
    return fallback;
  }
  return url;
}
